import React, { useState } from "react";
import { SlArrowDown } from "react-icons/sl";
import "./style.css";

const Question = ({ question, answer }) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <article className={`question ${showInfo ? "open" : ""}`} onClick={() => setShowInfo(!showInfo)}>
      <div className="singleQuestion">
        <h4 >{question}</h4>
        <SlArrowDown style={{flexShrink:"0"}} />
      </div>
      <div className={`answer ${showInfo ? "show" : ""}`}>
        <p>{answer}</p>
      </div>
    </article>
  );
};

export default Question;
